import axios from 'axios';
import {handleApiError} from 'middleware/errorHandler';
import {TRACK_API_BASE_URL} from 'utils/consts';

export const axiosInstance = axios.create({
  baseURL: TRACK_API_BASE_URL,
  timeout: 50000,
  withCredentials: true,
});

axiosInstance.interceptors.request.use((request) => {
  if (request.method !== 'get') {
    const csrfToken = document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrftoken='))
      ?.split('=')[1];
    if (csrfToken) {
      request.headers['X-CSRFToken'] = csrfToken;
    }
  }
  return request;
});

if (
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_LOCAL_S3_PROXY === 'true'
) {
  // eslint-disable-next-line global-require
  const {registerLocalDevAxiosInterceptors} = require('./axiosFuncs.local');
  registerLocalDevAxiosInterceptors(axiosInstance);
}

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const retryFunc = (func, retries = 2, interval = 500) => {
  return func().catch((err) => {
    if (retries <= 0) {
      handleApiError(err);
      return Promise.reject(err);
    }

    return new Promise(function (resolve) {
      setTimeout(function () {
        resolve(retryFunc(func, retries - 1, interval));
      }, interval);
    });
  });
};

export const retryGet = (url) => {
  return retryFunc(() => axiosInstance.get(url));
};

export const retryPost = (url, data) => {
  return retryFunc(() => axiosInstance.post(url, data));
};

export const retryPut = (url, data) => {
  return retryFunc(() => axiosInstance.put(url, data));
};
